export const SELA_MEMBER = 'Sela'
export const FT_MEMBER = 'SelaFT'
export const SELA_ROUTE = 'sel-for-adults'
export const FT_ROUTE = 'sel-for-adults-field-test'
